export default "__VITE_ASSET__7zjrg4VQ__"